<template>
     <div class="container">
        <ProductsMenu @productsSelect="productsSelect"/>
        <div>
<!--            <div class="introduction">-->
<!--                <div class="title" data-aos="fade-up">生物样本库建设整体规划服务</div>-->
<!--                <div class="introductionContent">-->
<!--                    <div><img :src="require('@/assets/img/products/service/serviceContent1.png')" data-aos="zoom-in-up"></div>-->
<!--                    <div data-aos="fade-down">上海唐顾信息技术有限公司提供生物样本库建设整体规划服务，为客户提供生物样本库建设咨询、规划设计等配套服务</div>-->
<!--                    <div><img :src="require('@/assets/img/products/service/serviceContent2.png')" data-aos="zoom-in-up"></div>-->
<!--                    <div data-aos="fade-right">上海唐顾信息技术有限公司的设计方案更注重生物样本库运营过程中的规范化管理</div>-->
<!--                    <div><img :src="require('@/assets/img/products/service/serviceContent3.png')" data-aos="zoom-in-up"></div>-->
<!--                    <div data-aos="fade-left">可因地制宜为客户提供兼具特色的生物样本库设计方案，为客户建设专业化标准化的样本库建设提供技术支撑</div>-->
<!--                </div>-->
<!--                <table class="introductionTable">-->
<!--                    <thead>-->
<!--                        <tr data-aos="fade-up">-->
<!--                            <td>序号</td>-->
<!--                            <td>名称</td>-->
<!--                            <td>内容</td>-->
<!--                        </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                        <tr v-for="item,index in introduction" data-aos="fade-up">-->
<!--                            <td>{{index+1}}</td>-->
<!--                            <td>{{item.name}}</td>-->
<!--                            <td>{{item.content}}</td>-->
<!--                        </tr>-->
<!--                    </tbody>-->
<!--                </table>-->
<!--            </div>-->
<!--            <div class="case">-->
<!--                <div class="title" data-aos="fade-up">ISO20387咨询培训服务</div>-->
<!--                <div class="content">-->
<!--                    <img :src="require('@/assets/img/products/service/caseContent.png')" data-aos="zoom-in-up">-->
<!--                    <div class="contentTitle" data-aos="fade-up">ISO20387咨询培训服务</div>-->
<!--                    <div class="text" data-aos="fade-up">ISO20387“生物技术-生物样本保藏-生物样本库通用要求”(以下简称ISO 20387)国际标准于2018年8月正式发布。2019年8月30日，国家市场监督管理总局(国家标准化管理委员会)发布2019年第10号中国国家标准公告批准GB/T 37864-2019《生物样本库质量和能力通用要求》(等同采用ISO 20387:2018)国家标准发布实施.SO 20387规定了生物样本库能力、公正性、持续运行(含质量控制》的通用要求，以确保生物样本和本准则数据的质量。生物样本库用户、监管机构、同行评估组织、认可机构均可使用ISO 20387来确认或承认生物样本库的能力。</div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="range">-->
<!--                <div class="title" data-aos="fade-up">适用范围</div>-->
<!--                <div class="rangeContent" data-aos="fade-up">ISO20387准则适用于所有从事生物样本保藏的机构，包括为研究和开发而保藏多细胞有机体(如人、动物、真菌和植物)及微生物的生物样本库。不适用于食物、种子生产、分析和治疗的生物样本。</div>-->
<!--                <div class="title" data-aos="fade-up">培训模块</div>-->
<!--                <div class="training">-->
<!--                    <div>-->
<!--                        <div class="trainingContent" data-aos="fade-up">-->
<!--                            <div>讲解</div>-->
<!--                            <div>︾</div>-->
<!--                        </div>-->
<!--                        <div class="trainingContent" data-aos="fade-up">-->
<!--                            <div>执行</div>-->
<!--                            <div>︾</div>-->
<!--                        </div>-->
<!--                        <div class="trainingContent" data-aos="fade-up">-->
<!--                            <div>评价</div>-->
<!--                            <div>︾</div>-->
<!--                        </div>-->
<!--                        <div class="trainingContent" data-aos="fade-up">-->
<!--                            <div>完善</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <img :src="require('@/assets/img/products/service/trainingContent.png')" data-aos="zoom-in-up">-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="trainingList">-->
<!--                <div class="trainingListContent" v-for="item in trainingList" data-aos="zoom-in">-->
<!--                    <div class="img"><img :src="item.img" alt=""></div>-->
<!--                    <div class="content">-->
<!--                        <span class="num">{{item.num}}</span>-->
<!--                        <span class="text">{{item.text}}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="service">-->
<!--                <div class="title" data-aos="fade-up">人类遗传资源管理行政审批服务</div>-->
<!--                <img :src="require('@/assets/img/products/service/serviceContent.png')" data-aos="zoom-in">-->
<!--                <div class="text" data-aos="fade-up">-->
<!--                    人类遗传资源包括人类遗传资源材料和人类遗传资源信息。人类遗传资源材料是指含有人体基因组、基因等遗传物页的器官、组织、细胞等遗传材料，人类遗传资源信息是指利用人类遗传资源材料产生的数据等信息资料。类遗传资源管理行政审批服务包括中国人类遗传资源采集审批、保藏审批、国际合作科学研究审批、遗传资源材料出境审批、国际合作临床试验备案、信息对外提供或开放使用备案。人类遗传资源采集活动，包括重要遗传家系(患病家系或具有遗传性特殊体质或生理特征成员五人以上，涉及三代)、特定地区人类遗传资源和国务院科学技术行政部门规定种类(罕见病、具有显著性差异的特殊体质或生理特征的人群)、数量(累积500人以上)-->
<!--                </div>-->
<!--                <div class="text" data-aos="fade-up">-->
<!--                    国际合作科学研究，是指与外国组织及外国组织、个人设立或者实际控制的机构(称外方单位)合作进行的科学研究活动; <br>信息对外提供或开放使用，指的是将人类溃传资源(以下简称人遗)向外国组织、个人及其设立或者实际控制的村勾提供或开放使用。-->
<!--                </div>-->
<!--                <div class="text" data-aos="fade-up">-->
<!--                    人类遗传资源采集、保藏、利用、对外提供过程中应当遵守《中华人民共和国人类遗传资源管理条例》 (国令第717号)等的相关规定。项目须在获得中国人类遗传资源管理办公室批准或备案后方可启动开展。-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="approval">-->
<!--                <div>-->
<!--                    <div class="title" data-aos="fade-up">审批流程</div>-->
<!--                    <div class="list">-->
<!--                        <div class="content" v-for="item,index in approvalList" data-aos="zoom-in">-->
<!--                            <div class="left">-->
<!--                                <div class="ellipse">-->
<!--                                    STEP-->
<!--                                    <br>-->
<!--                                    {{index+1}}-->
<!--                                </div>-->
<!--                                <div v-html="item" class="text"></div>-->
<!--                            </div>-->
<!--                            <div class="right">-->
<!--                                <i class="el-icon-arrow-right" v-if="index<3"></i>-->
<!--                                <i class="el-icon-arrow-left" v-else-if="index>3"></i>-->
<!--                                <i class="el-icon-arrow-down" v-else></i>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="third">
                <div class="title" data-aos="fade-up">生物样本第三方储存对接服务</div>
                <img :src="require('@/assets/img/products/service/third.png')" data-aos="zoom-in">
                <div class="text" data-aos="fade-up">生物样本库在基础研究、临床研究与转化研究领域发挥着重要作用，近年来受到政府、高校、科研院所、医疗机构及生物医药产业的广泛关注与快速发展。生物样本库建设对软硬件设施、安全管控、信息化能力及专业化管理均有着较高要求。部分医疗机构、科研团队缺少自建样本库条件，珍贵样本难以妥善保存；药企临床试验样本分散存放，难以实现集中统一管理；生物医药企业对细胞株等关键生物材料的高安全托管存在迫切需求。上海唐颐信息技术有限公司为客户提供第三方生物样本储存对接及配套技术服务，联动合规第三方储存资源，助力珍贵生物样本实现存得放心、取得便捷、用得高效。
                </div>
                <div class="service">
                    <div class="thirdTitle" data-aos="fade-up">服务板块</div>
                    <div class="list">
                        <div v-for="item,index in thirdService" data-aos="zoom-in">
                            <div><img :src="item.img" alt=""></div>
                            <div>{{item.text}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</template>

<script>
import ProductsMenu from "../../components/ProductsMenu";
export default {
    name:'Service',
    components: {ProductsMenu},
    data(){
      return {
        introduction:[
            {name:'实验室规划、布局、装修',content:'吊顶装修、隔墙装修、地面装修、圆弧结构门窗制作安装、不锈钢传递窗、手消毒系统'},
            {name:'实验室供电系统',content:'照明电器、紫外线灭菌灯、开关插座、动力配电心'},
            {name:'实验室自动化控制系统',content:'风机、空调、压力、通风橱、温湿度控制系统等'},
            {name:'实验室弱电规划',content:'视频监控、弱电综合网络系统'},
            {name:'实验室净化、空调、排风设计及施TE',content:'净化级别、送/回/排风系统、压差控制、净化空调机组、空调冷热源'},
            {name:'实验室配套',content:'水盆/水槽/水龙头、洗眼器/紧急喷淋系统滴水架、试剂架、中央实验台、实验边台高温台、天平台、不锈钢操作台、药品柜/器血柜/钢瓶柜/样品柜、通风橱/通风罩/原子吸收罩'},
        ],
        trainingList:[
            {
                img:require('@/assets/img/products/service/trainingList1.png'),
                num:'01',
                text:'诊断与策划'
            },
            {
                img:require('@/assets/img/products/service/trainingList2.png'),
                num:'02',
                text:'结构管理'
            },
            {
                img:require('@/assets/img/products/service/trainingList1.png'),
                num:'03',
                text:'人员管理'
            },
            {
                img:require('@/assets/img/products/service/trainingList4.png'),
                num:'04',
                text:'基础实施管理'
            },
            {
                img:require('@/assets/img/products/service/trainingList5.png'),
                num:'05',
                text:'过程管理'
            },
            {
                img:require('@/assets/img/products/service/trainingList6.png'),
                num:'06',
                text:'运行与改进'
            },

        ],
        approvalList:[
          '网上申请',
          '网上预受理',
          '纸质申请<br>材料提交',
          '纸质材料<br>审查与受理',
          '文书送达',
          '结果公布',
          '审批决定',
          '技术评审'
        ],
        thirdService:[
            {
                img:require('@/assets/img/products/service/thirdService1.png'),
                text:'样本运输技术对接服务'
            },
            {
                img:require('@/assets/img/products/service/thirdService2.png'),
                text:'样本处理技术配套服务'
            },
            {
                img:require('@/assets/img/products/service/thirdService3.png'),
                text:'样本存储对接服务'
            },
            {
                img:require('@/assets/img/products/service/thirdService4.png'),
                text:'样本质控服务'
            },
            {
                img:require('@/assets/img/products/service/thirdService5.png'),
                text:'样本数据存储'
            },
            {
                img:require('@/assets/img/products/service/thirdService6.png'),
                text:'样本数据共享'
            }
        ]
      }
    },
    methods:{
	    productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        .title{
            width: 417px;
            height: 58px;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #ed1c24;
            margin: 213px auto 116px;
            background: url('../../assets/img/products/service/serviceTitle.png') no-repeat;
            text-align: center;
        }
        .introductionContent{
            display: flex;
            flex-wrap: wrap;
            width: 1220px;
            margin: 0 auto;
            div{
                width: 406px;
                height: 222px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0 40px;
                box-sizing: border-box;
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 23px;
                letter-spacing: 1px;
                color: #000000;
            }
        }
        .introductionTable{
            width: 982px;
            margin: 136px auto 95px;
            thead{
                td{
                    height: 36px;
                    background: #e3efff;
                    font-size: 15px;
                    text-align: center;
                    letter-spacing: 1px;
                }
            }
            tbody{
                td{
                    font-size: 15px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                    background: #f3f3f3;
                    box-sizing: border-box;
                }
                td:nth-child(1){
                    width: 105px;
                    padding: 0;
                    text-align: center;
                }
                td:nth-child(2){
                    width: 366px;
                    padding: 30px 35px;
                }
                td:nth-child(3){
                    width: 504px;
                    padding: 11px 18px;
                }
            }
        }
    }
    .case{
        .title{
            width: 512px;
            height: 67px;
            background: url("../../assets/img/products/service/caseTitle.png") no-repeat;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #ed1c24;
            margin: 0 auto 76px;
            text-align: center;
            line-height: 30px;
        }
        .content{
            width: 100%;
            background: #e3efff;
            text-align: center;
            padding: 17px 0 69px;
            .contentTitle{
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 2px;
            }
            .text{
                width: 960px;
                margin: 7px auto 26px;
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 24px;
                letter-spacing: 1px;
                text-align: left;
                text-indent:2em;
            }
        }
    }
    .range{
        width: 956px;
        margin: 111px auto 0;
        .title{
            width: 127px;
            height: 27px;
            background-color: #006efd;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 27px;
            letter-spacing: 2px;
            color: #ffffff;
            text-align: center;
        }
        .rangeContent{
            width: 915px;
            margin: 30px 0 94px 23px;
            box-sizing: border-box;
            font-size: 15px;
            line-height: 20px;
            letter-spacing: 1px;
        }
        .training{
            margin-top: 88px;
            display: flex;
            .trainingContent{
                width: 304px;
                height: 95px;
                border-left: 5px solid #006efd;
                padding-left: 106px;
                box-sizing: border-box;
                padding-top: 22px;
                margin-bottom: 8px;
                div:nth-child(1){
                    width: 193px;
                    height: 51px;
                    line-height: 51px;
                    text-align: center;
                    font-size: 20px;
                    letter-spacing: 27px;
	                color: #006efd;
                    border: 1px solid #006efd;
                    box-sizing: border-box;
                    padding-left: 30px;
                }
                div:nth-child(2){
                    font-size: 20px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 23px;
                    letter-spacing: 2px;
                    color: #006efd;
                    text-align: center;
                    margin-top: 15px;
                }
            }
            .trainingContent:nth-child(2){
                border-color: #ed1c24;
            }
            &>div:nth-child(2){
                margin-left: 142px;
            }

        }
    }
    .trainingList{
        width: 100%;
        height: 687px;
        background: url("../../assets/img/products/service/trainingListBg.png") no-repeat;
        display: flex;
        box-sizing: border-box;
        flex-wrap: wrap;
        padding: 115px 278px;
        justify-content: space-between;
        .trainingListContent{
            width: 25.1%;
            .img{
                width: 115px;
                height: 115px;
                background:rgba(0,160,233,0.08);
                border: solid 1px rgba(0,0,0,0.08);
                border-radius: 50%;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                margin:  0 auto;
            }
            .content{
                margin-top: 15px;
                display: flex;
                justify-content: center;
                span{
                    display: inline-block;
                }
                span:nth-child(1){
                    font-size: 30px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 2px;
                    color: #ffffff;
                    height: 37px;
                    line-height: 37px;
                }
                span:nth-child(2){
                    font-size: 20px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 2px;
                    color: #ffffff;
                    border-left: 1px solid #fff;
                    height: 37px;
                    line-height: 37px;
                    margin-left: 15px;
                    padding-left: 13px;
                }
            }
        }
        .trainingListContent:nth-child(n+4){
            margin-top: 90px;
        }
    }
    .service{
        text-align: center;
        .title{
            width: 502px;
            height: 67px;
            line-height: 30px;
            text-align: center;
            margin: 55px auto 65px;
            background: url("../../assets/img/products/service/approvalTitle.png") no-repeat;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #ed1c24;

        }
        img{
            margin-bottom: 64px;
        }
        .text{
            width: 1030px;
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 1px;
            color: #333333;
            margin: 0 auto;
            text-indent: 2em;
            text-align: left;
        }
    }
    .approval{
        width: 100%;
        height: 687px;
        background: url("../../assets/img/products/service/approvalBg.png");
        margin-top: 75px;
        &>div{
            width: 1000px;
            margin: 0 auto;
            padding-top: 80px;
            .title{
                width: 127px;
                height: 27px;
                background-color: #006efd;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 27px;
                letter-spacing: 2px;
                color: #ffffff;
                margin-bottom: 90px;
                text-align: center;
            }
            .list{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .content{
                    display: flex;
                    padding-left: 45px;
                    margin-bottom: 97px;
                    .left{
                        width: 118px;
                        height: 130px;
                        background-color: #ffffff;
                        border-radius: 10px;
                        .ellipse{
                            margin-left: 32.5px;
                            margin-top: -22.5px;
                            width:45px;
                            height:45px;
                            background: #006efd;
                            border-radius: 100px;
                            text-align: center;
                            color: #fff;
                            font-size: 10px;
                            padding-top: 6px;
                            box-sizing: border-box;
                            &:after{
                                content: '';
                                display:inline-block;
                                width:47px;
                                height: 32.5px;
                                position:relative;
                                opacity: 0.25;
                                background: #006efd;
                                top:-40%;
                                left:-1px;
                                border-bottom-left-radius: 50px;
                                border-bottom-right-radius: 50px;
                            }
                        }
                        .text{
                            text-align: center;
                            margin-top: 30px;
                            font-size: 15px;
                            line-height: 25px;
                        }
                    }
                    .right{
                        width: 76px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        i{
                            color: #fff;
                            font-size: 30px;
                        }
                    }
                }
            }
        }

    }
    .third{
        text-align: center;
        margin-top: 80px;
        .title{
            width: 360px;
            height: 67px;
            line-height: 30px;
            background: url("../../assets/img/products/service/thirdTitle.png") no-repeat;
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #ed1c24;
            margin: 0 auto;
            text-align: center;
        }
        &>img{
            margin: 65px 0;
        }
        .text{
            width: 1030px;
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 1px;
            color: #333333;
            text-indent: 2em;
            margin: 0 auto;
            text-align: left;
        }
        .service{
            width: 1030px;
            margin: 78px auto;
           .thirdTitle{
                width: 127px;
                height: 27px;
                background-color: #006efd;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 27px;
                letter-spacing: 2px;
                color: #ffffff;
                text-align: center;
            }
            .list{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-top: 78px;
                &>div{
                    width: 276px;
                    height: 250px;
                    margin-bottom: 20px;
                    padding-top: 53px;
                    box-sizing: border-box;
                    &>div:nth-child(1){
                        width: 80px;
                        height: 80px;
                        border-radius: 80px;
                        border: 1px solid #fff;
                        margin:  0 auto 34px;
                        text-align: center;
                        padding-top: 15px;
                        box-sizing: border-box;
                        img{
                            width: 50px;
                        }
                    }
                    &>div:nth-child(2){
                        font-size: 19px;
                        font-weight: normal;
                        font-stretch: normal;
                        line-height: 27px;
                        letter-spacing: -1px;
                        color: #ffffff;
                    }
                }
                &>div:nth-child(n){
                    background-color: #006efd
                }
                &>div:nth-child(2n){
                    background-color: #c1dcff;
                }
                &>div:nth-child(1){
                    &>div:nth-child(1){
                        padding-top: 25px;
                    }
                }
                &>div:nth-child(3){
                    &>div:nth-child(1){
                        padding-top: 16px;
                        img{
                            margin-left: 5px;
                        }
                    }
                }
                &>div:nth-child(6){
                    &>div:nth-child(1){
                        padding-top: 12px;
                        img{
                            margin-left: -5px;
                        }
                    }
                }
            }
        }

    }
</style>
